import { unitRegistry } from '@/helpers/unit-formatter/shared/instance';

export default unitRegistry.transformers;
